module.exports = __webpack_public_path__ + "media/images/emblems/Daerstetten-coat_of_arms-fd4b544d05c29ef3051c1bf683f39a10.svg";